<yc-alert *ngIf="emailAlertMessage"
  alertClass="danger"
  [message]="emailAlertMessage">
</yc-alert>